import QuizPeriod from '@/pages/quiz_period/QuizPeriod'

const routes = [
  {
    path: '/quiz-period',
    name: 'QuizPeriod',
    component: QuizPeriod,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_ADMIN']
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/quiz_period.js